module.exports = __webpack_public_path__ + "static/img/pinpai-1.a3a6599c.png";